import React from "react";

type Props = {};

const WorkSimpliSuite = (props: Props) => {
  return (
    <section className="industries-categories-feature">
      <div className="container py-2">
        <div className="header">
          {/* <h2>As an added bonus when you sign up for any of the above</h2>
                    <p className="sub-headline">LegalSimpli plans you will have full access to ALL the WorkSimpli suite of products.</p> */}
          <h2>As an added bonus </h2>
          <p className="sub-headline">You now have full access to ALL the WorkSimpli suite of products</p>
        </div>
        <div className="row row-eq-height our-brands text-center">
          <div className="col-md-6 col-lg-4 mb-4">
            <div className="icon pb-3">
              <img src={process.env.PUBLIC_URL + "/static/images/PDFSimpli-logo.svg"} alt="PDFSimpli" />
            </div>

            <p>
              <b>PDFSimpli </b> helps you modify, edit, store, convert, and add e-signatures to almost any document,
              with multiple users and unlimited storage. All done from just one web-based, simple platform that will
              boost your productivity!
            </p>
          </div>
          <div className="col-md-6 col-lg-4 mb-4">
            <div className="icon pb-3">
              <img src={process.env.PUBLIC_URL + "/static/images/signsimpli-logo.svg"} alt="SIGNSimpli" />
            </div>
            <p>
              <b>SignSimpli </b> is the easiest way to add electronic signatures to documents using hundreds of
              templates of the most common legal documents, including sales contracts, NDAs, sales agreements,
              onboarding paperwork, mortgage, escrows, and financial agreements.
            </p>
          </div>
          <div className="col-md-6 col-lg-4 mb-4">
            <div className="icon pb-3">
              <img
                className="rb-sellpage-logo"
                src={process.env.PUBLIC_URL + "/static/images/resumebuild.svg"}
                alt="RESUMEbuild"
              />
            </div>
            <p>
              <b>ResumeBuild</b> allows you to create a perfect resume and cover letter with professional,
              out-of-the-box templates and step-by-step instructions, instantly generated by the most advanced resume
              builder technology available. Available in English, French, Spanish and Italian.
            </p>
          </div>
          <div className="col-md-6 col-lg-6 mb-4">
            <div className="icon pb-3">
              <img src={process.env.PUBLIC_URL + "/static/images/legalsimpli-logo.svg"} alt="LEGALSimpli" />
            </div>
            <p>
              <b>LegalSimpli </b> it’s the most affordable and effortless way of creating legal documents without hiring
              an attorney just by choosing from our library of hundreds of legal documents and common business forms for
              individuals and businesses.
            </p>
          </div>
          <div className="col-sm-6 col-md-12 col-lg-6 mb-4">
            <div className="icon">
              <img src={process.env.PUBLIC_URL + "/static/images/docusimpli-logo.svg"} alt="DOCUSimpli" />
              <span className="d-block mt-1" style={{ color: "#f9593a", fontSize: "13px", fontWeight: "bold" }}>
                COMING SOON
              </span>
            </div>
            <p>
              <b>DocuSimpli </b> allows you to upload, edit, capture, and extract data or images effortlessly from just
              one place and then download directly to the format of your preference in just minutes!
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WorkSimpliSuite;
